import React from 'react';
import { createRoot } from 'react-dom/client';
import elGR from 'antd/lib/locale/el_GR';
import 'moment/locale/el';
import { ConfigProvider } from 'antd';
import 'antd/dist/antd.min.css'
import { QueryClient, QueryClientProvider } from "react-query";
import { AuthContextProvider } from './shared/context/auth-context';


import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container);
const queryClient = new QueryClient({ defaultOptions: { queries: { cacheTime: 0 ,retry:false } } });



root.render(
  <AuthContextProvider>
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <ConfigProvider locale={elGR}>
          <App />
        </ConfigProvider>
      </QueryClientProvider>
    </React.StrictMode>
  </AuthContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
